import { cn } from '@/lib/cn';

/**
 * Spinner simples para estados de loading.
 */
export function Spinner({
  label = 'Carregando',
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2 text-sm text-slate-600', className)} role="status">
      <span
        aria-hidden="true"
        className="h-5 w-5 animate-spin rounded-full border-2 border-slate-200 border-t-niteroi-600"
      />
      <span>{label}…</span>
    </div>
  );
}
